/**
 * Given an array and an item within the array, returns the following item.
 */
export default function getNextItem<T>(items: T[], current?: T): T {
  return items[items.indexOf(current) + 1];
}
